<template>
  <section class="navbar">
    <v-card color="grey lighten-4 navbar" flat tile>
      <!-- ================================= navbar component ======================================== -->
      <v-toolbar color="#13a8b1">
        <v-app-bar-nav-icon
          @click="drawer = !drawer"
          color="#ffffff"
        ></v-app-bar-nav-icon>

        <v-toolbar-title>
          <router-link
            to="/"
            style="text-decoration: none; display: inline-block"
            class="logo"
          >
            <img src="../assets/logo.png" class="logo-image" width="50px" alt />
          </router-link>
        </v-toolbar-title>
        <v-btn icon large @click="changeLanguage">
          <span class="white--text">{{ lang }}</span>
        </v-btn>

        <div class="links text-center desktop-only" v-if="teacherOrStudent">
          <p style="display: inline-block" v-if="type == 'Student'">
            <router-link to="/teachers" class="nav-link">
              <v-icon large class="white--text">groups</v-icon>
              {{ $t("teachers") }}</router-link
            >
          </p>
          <p style="display: inline-block">
            <router-link :to="appointmentsRoute" class="nav-link">
              <v-icon large class="white--text">alarm</v-icon>
              {{ $t("Appointments") }}
            </router-link>
          </p>
        </div>

        <v-spacer></v-spacer>

        <v-btn icon large link to="/market" class="desktop-only">
          <v-icon color="#ffffff" large>shopping_basket</v-icon>
        </v-btn>
        <v-btn icon large link to="/market/cart" class="cart desktop-only">
          <v-badge
            color="#FFC382"
            :content="cartItemsCount > 0 ? cartItemsCount : '0'"
          >
            <v-icon color="#ffffff" large>shopping_cart</v-icon>
          </v-badge>
          <!-- <v-icon color="#ffffff" medium>shopping_cart</v-icon> -->
        </v-btn>
        <v-btn
          icon
          small
          class="signUp-btn"
          @click="goToLoginPage"
          v-if="!isLoggedIn"
          >{{ $t("Login") }}</v-btn
        >

        <!-- <v-btn icon large class="signUp-btn" @click="logout" v-else>تسجيل الخروج</v-btn> -->
        <v-menu
          v-if="teacherOrStudent && type == 'Teacher'"
          v-model="wallet"
          offset-y
          :close-on-content-click="false"
          nudge-width="300"
          max-width="400"
          offset-x
        >
          <!-- :close-on-click="false" -->
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="transparent"
              icon
              class="filter-btn"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon large color="#ffffff">credit_card</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item class="text-center">
                <p class="main-color" style="width: 100%">{{ $t("wallet") }}</p>
              </v-list-item>

              <v-list-item class="text-center">
                <p class="grey--text" style="width: 100%">
                  <strong class="main-color" style="display: block">{{
                    $t("cachAvailable")
                  }}</strong>
                  <strong>{{ teacherBalance }} {{ $t("currency") }}</strong>
                </p>
              </v-list-item>
              <v-list-item class="text-center">
                <v-btn
                  class="third-btn"
                  @click="requestWithdraw"
                  v-if="teacherBalance > 0 && !hasPendingWithdraws"
                  >{{ $t("transactionRequest") }}</v-btn
                >
                <p
                  class="text-center main-color"
                  v-if="teacherBalance > 0 && hasPendingWithdraws"
                >
                  {{
                    $t(
                      " Your request is being processed. You can submit one withdraw request at a time."
                    )
                  }}
                </p>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-btn
          icon
          link
          to="/student/wallet"
          v-if="teacherOrStudent && type == 'Student'"
          class="desktop-only"
        >
          <v-icon color="#ffffff" large>credit_card</v-icon>
        </v-btn>

        <!-- notifications icon  -->
        <v-menu
          offset-y
          style="z-index: 1111 !important"
          id="account-menu"
          v-if="isLoggedIn"
          max-width="400px"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-badge
                color="#FFC382"
                :content="notifications.length > 0 ? notifications.length : '0'"
              >
                <v-icon color="#FFC382" large>notifications</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list id="accountMenu" two-line>
            <v-list-item
              v-for="(notification, index) in notifications"
              :key="index"
              link
            >
              <v-list-item-title class="item.class">
                {{ notification.body }}
                <p class="grey--text darken">
                  <v-icon small>watch_later</v-icon>
                  <span class="blue--text">{{ notification.time }} </span>
                </p>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="notifications.length == 0">
              <v-list-item-title>
                {{ $t("noNotification") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="readNotification"
              v-if="notifications.length > 0"
            >
              <v-list-item-title class="text-center showAll blue--text">
                {{ $t("Read notifications") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
          offset-y
          style="z-index: 1111 !important; width: 200px"
          id="account-menu"
          v-if="isLoggedIn"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon color="#ffffff" large>person</v-icon>
            </v-btn>
          </template>
          <v-list id="accountMenu">
            <v-list-item link :to="profileRoute" v-if="teacherOrStudent">
              <v-list-item-title class="item.class">
                <v-icon>person</v-icon>
                {{ $t("Profile") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              to="/teacher/profilesettings"
              v-if="type == 'Teacher'"
            >
              <v-list-item-title class="item.class">
                <v-icon>settings</v-icon>
                {{ $t("Account Setting") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              to="/student/profilesettings"
              v-if="type == 'Student'"
            >
              <v-list-item-title class="item.class">
                <v-icon>settings</v-icon>
                {{ $t("Account Setting") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              link
              to="/market/profilesettings"
              v-if="type == 'Market'"
            >
              <v-list-item-title class="item.class">
                <v-icon>settings</v-icon>
                {{ $t("Account Setting") }}
              </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item link to="/student/wallet" v-if="type == 'Student'">
              <v-list-item-title class="item.class">
                <v-icon>credit_card</v-icon>
                {{ $t("my wallet") }}
              </v-list-item-title>
            </v-list-item> -->
            <v-list-item link to="/market/addresses" v-if="isLoggedIn">
              <v-list-item-title class="item.class">
                <v-icon>home</v-icon>
                {{ $t("Addresses") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="logout">
              <v-list-item-title class="item.class">
                <v-icon>reply</v-icon>
                {{ $t("logout") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-card>

    <!-- ========================== sidbar Component ======================================= -->
    <v-navigation-drawer
      v-model="drawer"
      class="sidebar"
      v-if="drawer == true"
      absolute
      temporary
      :right="locale == 'en' ? false : true"
    >
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item class="sidebarItem mb-12">
            <img src="../assets/second-logo.png" class="sidebarlogo" alt="" />
          </v-list-item>
          <v-list-item class="sidebarItem">
            <v-list-item-title>
              <router-link class="nav-link" to="/">
                <v-icon class="white--text">home</v-icon>
                <strong>
                  {{ $t("Home") }}
                </strong>
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="sidebarItem" v-if="type != 'Teacher'">
            <v-list-item-title>
              <router-link to="/teachers" class="nav-link">
                <v-icon class="white--text">groups</v-icon>
                <strong> {{ $t("teachers") }} </strong>
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="sidebarItem" v-if="teacherOrStudent">
            <v-list-item-title>
              <router-link :to="appointmentsRoute" class="nav-link">
                <v-icon class="white--text">alarm</v-icon>
                <strong>
                  {{ $t("Appointments") }}
                </strong>
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="sidebarItem">
            <v-list-item-title class="main-color">
              <router-link to="/market" class="nav-link">
                <v-icon>shopping_cart</v-icon>
                <strong>
                  {{ $t("Store") }}
                </strong>
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="sidebarItem d-none"
            :class="locale == 'en' ? 'subItemLtr' : 'subItemrtl'"
          >
            <v-list-item-title class="main-color">
              <router-link to="/market" class="nav-link">
                <v-icon>category</v-icon>
                {{ $t("Categories") }}
              </router-link></v-list-item-title
            >
          </v-list-item>
          <v-list-item class="sidebarItem" v-if="isLoggedIn">
            <v-list-item-title class="main-color">
              <router-link to="/market" class="nav-link">
                <v-icon>favorite</v-icon>
                {{ $t("favourite") }}
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="sidebarItem" v-if="isLoggedIn">
            <v-list-item-title class="main-color">
              <router-link to="/market/cart" class="nav-link">
                <v-icon>shopping_cart</v-icon>
                {{ $t("shopping_cart") }}
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="sidebarItem"
            v-if="teacherOrStudent && type == 'Student'"
          >
            <v-list-item-title class="main-color">
              <router-link to="/student/wallet" class="nav-link">
                <v-icon color="#ffffff">credit_card</v-icon>
                {{ $t("wallet") }}
              </router-link></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="sidebarItem" @click="changeLanguage">
            <v-list-item-title class="main-color">
              <router-link :to="appointmentsRoute" class="nav-link">
                <v-icon>language</v-icon>
                <strong>
                  {{ lang }}
                </strong>
              </router-link></v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <Snack ref="snack"></Snack>
    <notificationpopup ref="notification"></notificationpopup>
  </section>
</template>

<script>
import notificationpopup from "../components/notificationpopup";
import AUTH from "../auth";

export default {
  name: "navbar",
  data() {
    return {
      drawer: false,
      group: null,
      lang:
        localStorage.locale == "ar"
          ? this.$i18n.t("english")
          : this.$i18n.t("arabic"),
      notifications: [],
      wallet: false,
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,
      locale: localStorage.locale,
      teacherOrStudent: AUTH.teacherOrStudent(),
      profileRoute: "",
      type: AUTH.type(),
      appointmentsRoute: "",
      teacherBalance: 0,
      hasPendingWithdraws: false,
      currentRouteName: this.$route.name,
      cartItemsCount: 0,
    };
  },
  watch: {
    drawer: {
      handler(value) {
        if (value) {
          document.addEventListener("keydown", (event) => {
            if (event.keyCode === 27) {
              this.drawer = false;
            }
          });
        } else {
          document.removeEventListener("keydown", function () {
            //
          });
        }
      },
    },
  },
  methods: {
    goToLoginPage() {
      if (window.location.pathname.split("/")[1] == "market") {
        this.$router.push({ path: "/market/login" });
      } else {
        this.$router.push({ path: "/login" });
      }
    },
    logout() {
      this.$http
        .post(
          this.getApiUrl + "/logout",
          {},
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((res) => {
          if (res.data.status.error) {
            this.$refs.toaster.sendDangerAlert(res.data.status.message);
          }
          this.resetLoginData();
          if (window.location.pathname.split("/")[1] == "market") {
            window.location = "/market";
          } else {
            window.location = "/";
          }
        });
    },
    changeLanguage() {
      if (localStorage.locale == "ar") {
        // this.lang = this.$i18n.t("english");
        localStorage.locale = "en";
      } else {
        // this.lang = this.$i18n.t("arabic");
        localStorage.locale = "ar";
      }
      if (this.isLoggedIn) this.changeUserLocale();
      location.reload();
    },
    changeUserLocale() {
      this.$http
        .post(
          this.getApiUrl + "/locale/change",
          { locale: localStorage.locale },
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((res) => {
          //
        });
    },
    resetLoginData() {
      localStorage.removeItem("isLoggedIn");

      localStorage.removeItem("token");
      localStorage.removeItem("avatar");
      localStorage.removeItem("type");
      localStorage.removeItem("id");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
    },
    getCartItemsCount() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/cart/count?cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          }
        )
        .then((res) => {
          if (res.data.status.error == false) {
            this.cartItemsCount = res.data.data.count;
          }
        });
    },
    getBalance() {
      if (this.type == "Teacher") {
        this.$http
          .get(this.getApiUrl + "/teacher/getBalance", {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then((res) => {
            if (res.data.status.error == false) {
              this.teacherBalance = res.data.data.balance;
              this.hasPendingWithdraws = res.data.data.hasPendingWithdraws;
            }
          });
      }
    },
    requestWithdraw() {
      this.$http
        .get(this.getApiUrl + "/teacher/withdraw/request", {
          headers: {
            locale: localStorage.locale,
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((res) => {
          if (res.data.status.error == false) {
            this.$refs.snack.sendSuccessAlert(res.data.status.message);
            this.getBalance();
          }
        });
    },

    getNotification() {
      if (this.isLoggedIn) {
        this.notifications = [];
        this.$http
          .get(this.getApiUrl + "/notifications", {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          })
          .then((response) => {
            if (response.data.status.error == false) {
              this.notifications = response.data.data;
            }
          });
      }
    },
    readNotification() {
      this.$http
        .get(this.getApiUrl + "/notifications/read", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.notifications = [];
          }
        });
    },
  },
  mounted() {
    // console.log(localStorage.isLoggedIn);
    this.$bus.$on("cartChanged", () => {
      this.getCartItemsCount();
    });
    this.lang =
      localStorage.locale == "en"
        ? this.$i18n.t("arabic")
        : this.$i18n.t("english");
    if (AUTH.type() == "Teacher") {
      this.profileRoute = "/teacher/profile";
      this.appointmentsRoute = "/teacher/appointments";
      this.getBalance();
    } else if (AUTH.type() == "Student") {
      this.profileRoute = "/student/profile";
      this.appointmentsRoute = "/student/appointments";
    }

    this.getNotification();
    this.getCartItemsCount();

    if (window.location.protocol == "https:") {
      this.$socket
        .channel("NotificationReceived")
        .listen("NotificationReceived", (e) => {
          console.log(parseInt(e.user_id) == parseInt(AUTH.getID()));
          if (parseInt(e.user_id) == parseInt(AUTH.getID())) {
            this.notifications.unshift(e.notification);
            this.$refs.notification.sendNotification(e.notification.body);
          }
        });
    }
  },
  components: {
    notificationpopup,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";
@import "../assets/styles/vuetifyCustomstyle.css";
@import "../assets/styles/_navbar.scss";
@import "../assets/styles/_responsive.scss";
</style>
